
import React from 'react'
import { render } from 'react-dom'
import { Router, Route, IndexRedirect, browserHistory, applyRouterMiddleware } from 'react-router'
import { useScroll } from 'react-router-scroll'
import { Provider as ReduxProvider } from 'react-redux'
import { ApolloProvider } from 'react-apollo'
import configureStore from 'store'
import { createClient as createApolloClient } from './graphql'
import { trackTimeTillInteractive } from 'lib/utils/stats'
import NotFound from 'ui/NotFound'
import LoginApp from './containers/LoginApp'
import SignupApp from './containers/SignupApp'
import ForgotApp from './containers/ForgotApp'
import ResetApp from './containers/ResetApp'
import ReceiptApp from './containers/ReceiptApp'
import WorkspaceApp from './containers/WorkspaceApp'
import ActivityApp from './containers/ActivityApp'
import CustomersApp from './containers/CustomersApp'
import CustomersProfilesApp from './containers/CustomersProfilesApp'
import CustomersProfileApp from './containers/CustomersProfileApp'
import CustomersSettingsApp from './containers/CustomersSettingsApp'
import CustomersProfileAppOverview from './containers/CustomersProfileAppOverview'
import CustomersProfileAppTraits from './containers/CustomersProfileAppTraits'
import CustomersProfileAppEvents from './containers/CustomersProfileAppEvents'
import IntegrationsCatalogOverviewApp from './containers/IntegrationsCatalogOverviewApp'
import IntegrationsCatalogDetailApp from './containers/IntegrationsCatalogDetailApp'
import './index.css'

const store = configureStore()
const apolloClient = createApolloClient()

const app = (
  <ReduxProvider store={store}>
    <ApolloProvider client={apolloClient}>
      <Router history={browserHistory} render={applyRouterMiddleware(useScroll())}>
        <Route path='/login' component={LoginApp} />
        <Route path='/signup' component={SignupApp} />
        <Route path='/forgot' component={ForgotApp} />
        <Route path='/reset' component={ResetApp} />
        <Route path='/:workspaceSlug' component={WorkspaceApp}>
          <Route path='activity' component={ActivityApp} />
          <Route path='customers' component={CustomersApp}>
            <IndexRedirect to='profiles' />
            <Route path='profiles' component={CustomersProfilesApp} />
            <Route path='settings' component={CustomersSettingsApp} />
          </Route>
          <Route path='customers/profiles/:profileId' component={CustomersProfileApp}>
            <IndexRedirect to='overview' />
            <Route path='overview' component={CustomersProfileAppOverview} />
            <Route path='traits' component={CustomersProfileAppTraits} />
            <Route path='events' component={CustomersProfileAppEvents} />
          </Route>
          <Route path='integrations'>
            <Route path='catalog' component={IntegrationsCatalogOverviewApp} />
            <Route path='catalog/:integrationSlug' component={IntegrationsCatalogDetailApp} />
          </Route>
        </Route>
        <Route path='/:workspaceSlug/settings/billing/payments/:chargeId' component={ReceiptApp} />
        <Route path='*' component={NotFound} />
      </Router>
    </ApolloProvider>
  </ReduxProvider>
)

render(app, document.querySelector('main'), () => trackTimeTillInteractive('spa'))



// WEBPACK FOOTER //
// ./index.js